<template>
  <div id="ebShare">
    <span>分享</span>
    <i class="icon iconfont icon-fenxiang"></i>
    <span>关注</span>
    <i class="icon iconfont icon-wujiaoxing"></i>
    <span>质疑澄清:</span>
    <span>-</span>
  </div>
</template>
<script>
export default {
  name: 'ebShare'
};
</script>
<style scoped lang="less">
 #ebShare{
   display: flex;
  i{
    color:#fb5b3b;
    font-size:18px;
    margin:0 7px 0 5px;
  }
 }
</style>
